import { render, staticRenderFns } from "./StructureWorkspace.vue?vue&type=template&id=18fc2ef1&scoped=true"
import script from "./StructureWorkspace.vue?vue&type=script&lang=js"
export * from "./StructureWorkspace.vue?vue&type=script&lang=js"
import style0 from "./StructureWorkspace.vue?vue&type=style&index=0&id=18fc2ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc2ef1",
  null
  
)

export default component.exports